import React, { useEffect, useState, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Table, Drawer, Popconfirm,
  Switch,
  Button,
  Alert,
} from 'antd';
import {
  EditOutlined, DeleteOutlined, ReloadOutlined, SettingOutlined,
} from '@ant-design/icons';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import closeIcon from '@Images/icons/icon-close-blue.png';
import CurrenciesActions from '@Actions/configurations/currenciesAction';
import UserActions from '@Actions/userActions';
import dayjs from 'dayjs';
import CurrenciesData from '@Apis/currencyConstant';
import CurrenciesForm from './CurrenciesForm';
import './style.scss';

/**
 *
 */
const Currencies = ({
  user, getCurrencies, CurrenciesResults, getCurrenciesLoading, updateCurrenciesLoading, deleteCurrencies, deleteCurrenciesLoading, getCurrencyConversionRate, getCurrencyConversionRateLoading, currencyConversionRateResults, refreshCurrencyConversionRate, refreshCurrencyConversionRateLoading, updateOrg, updateOrgLoading, getUserProfile,
}) => {
  const [showNewCurrencyModal, setShowNewCurrencyModal] = useState(false);

  const [showUpdateCurrencyModal, setShowUpdateCurrencyModal] = useState(false);

  const [selectedCurrency, setSelectedCurrency] = useState([]);

  const [globalConfig, setGlobalConfig] = useState(null);

  const [defaultCurrency, setDefaultCurrency] = useState('');

  const [currencies, setCurrencies] = useState([]);

  useEffect(() => {
    getCurrencies(user?.tenant_info?.org_id);
  }, []);

  useEffect(() => {
    if (CurrenciesResults) {
      const defCurrency = CurrenciesResults?.filter((currency) => currency?.is_default);
      setDefaultCurrency(defCurrency?.[0].currency_code);
    }
  }, [CurrenciesResults]);

  useEffect(() => {
    if (defaultCurrency) {
      getCurrencyConversionRate({ defaultCurrency });
    }
  }, [defaultCurrency]);

  useEffect(() => {
    if (currencyConversionRateResults) {
      const tempCurrenciesData = JSON.parse(JSON.stringify(CurrenciesData));

      const conversionRates = currencyConversionRateResults?.[0]?.conversion_rates;

      Object.keys(tempCurrenciesData).forEach((currency) => {
        tempCurrenciesData[currency].currency_conversion_rate = conversionRates[currency];
      });
      setCurrencies(tempCurrenciesData);
    }
  }, [currencyConversionRateResults]);

  useEffect(() => {
    if (user) {
      setGlobalConfig(user?.tenant_info?.global_config);
    }
  }, [user]);

  const currenciesListColumns = [
    {
      title: 'Currencies Name',
      render: (text, record) => (
        <Fragment>
          {`${record?.currency_code} (${record?.currency_symbol})    `}
          {record?.is_default
          && (
            <span
              className="status-tag"
            >
              Default
            </span>
          )}
        </Fragment>
      ),
    },
    {
      title: 'Manual Conversion Rate',
      render: (text, record) => (
        <Fragment>
          {record?.conversion_rate}
        </Fragment>
      ),
    },
    {
      title: 'Automatic Conversion Rate',
      render: (text, record) => (
        <Fragment>
          {record?.automatic_conversion_rate}
        </Fragment>
      ),
    },
    {
      title: '',
      key: 'action',
      render: (text, record) => (
        <div style={{
          textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center',
        }}
        >
          <div
            style={{
              cursor: record?.is_default ? 'not-allowed' : 'pointer',
              opacity: record?.is_default ? '0.5' : '1',
            }}
            className={`roundIconButton ${record?.is_default ? 'disabledButton' : ''}`}
            onClick={() => {
              if (!record?.is_default) {
                setShowUpdateCurrencyModal(true);
                setSelectedCurrency(record);
              }
            }}
          >
            <EditOutlined />
          </div>
          {record?.is_default ? (
            <div
              className={`currencies_deleteButton ${record?.is_default ? 'disabledButton' : ''}`}
              style={{
                cursor: record?.is_default ? 'not-allowed' : 'pointer',
                opacity: record?.is_default ? '0.5' : '1',
              }}
            >
              <DeleteOutlined />
            </div>
          ) : (
            <Popconfirm
              placement="topRight"
              title="Are you sure you want to delete this currency?"
              onConfirm={() => {
                deleteCurrencies({ org_currency_id: record?.org_currency_id }, () => {
                  getCurrencies(user?.tenant_info?.org_id);
                });
              }}
              okText="Yes"
              cancelText="No"
            >
              <div
                className="currencies_deleteButton"
                style={{ cursor: 'pointer' }}
              >
                <DeleteOutlined />
              </div>
            </Popconfirm>
          )}
        </div>
      ),
    },
  ];

  const handleConversionRateConfig = (value) => {
    const payload = {
      org_id: user?.tenant_info?.org_id,
      global_config: {
        ...globalConfig,
        settings: {
          ...globalConfig.settings,
          automatic_conversion_rate: value,
        },
      },
    };
    updateOrg(payload, () => {
      getUserProfile();
    });
  };

  return (
    <Fragment>
      <div className="currencies__wrapper">
        <div className="ant-row">
          <div className="ant-col-md-18">
            {CurrenciesResults?.length && (
              <Alert
                style={{ padding: '18px', boxSizing: 'border-box' }}
                description={(
                  <div style={{
                    display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: '45px', marginTop: '-10px',
                  }}
                  >
                    <div style={{
                      display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', gap: '25px',
                    }}
                    >
                      <H3Text text="Would you like to use Automatic Currency Conversion Rate?" />
                      <div style={{ textAlign: 'center' }}>
                        <H3Text text="Is Automatic?" style={{ fontSize: '10px' }} />
                        <Switch
                          checked={globalConfig?.settings?.automatic_conversion_rate}
                          onChange={(value) => {
                            handleConversionRateConfig(value);
                          }}
                          checkedChildren="Yes"
                          unCheckedChildren="No"
                          loading={getCurrenciesLoading || updateOrgLoading}
                          disabled={updateOrgLoading || getCurrenciesLoading || updateCurrenciesLoading || deleteCurrenciesLoading || getCurrencyConversionRateLoading || refreshCurrencyConversionRateLoading}
                        />
                      </div>
                    </div>
                    <div style={{
                      width: 'fit-content', display: `${globalConfig?.settings?.automatic_conversion_rate ? 'flex' : 'none'}`, flexDirection: 'column', alignItems: 'center', marginLeft: '25px',
                    }}
                    >
                      <H3Text
                        text={`Last Updated - ${dayjs(CurrenciesResults?.filter((curr) => curr?.is_default)?.[0]?.updated_at).format('DD/MM/YYYY')}`}
                        style={{
                          fontSize: '11px',
                          color: dayjs(CurrenciesResults?.filter((curr) => curr?.is_default)?.[0]?.updated_at).format('DD/MM/YYYY') === dayjs(new Date()).format('DD/MM/YYYY') ? 'green' : 'red',
                          fontWeight: 'bold',
                        }}
                      />
                      <Button
                        type="link"
                        icon={<ReloadOutlined spin={refreshCurrencyConversionRateLoading} />}
                        size="small"
                        disabled={!defaultCurrency || getCurrenciesLoading || updateCurrenciesLoading || deleteCurrenciesLoading || getCurrencyConversionRateLoading || updateOrgLoading}
                        loading={refreshCurrencyConversionRateLoading}
                        onClick={() => {
                          refreshCurrencyConversionRate({ base_currency: defaultCurrency, org_id: user?.tenant_info?.org_id }, () => {
                            getCurrencies(user?.tenant_info?.org_id);
                          });
                        }}
                      >
                        Refresh
                      </Button>
                    </div>
                  </div>
                )}
                type="success"
              />
            )}
            <div className="currencies__table__wrapper">
              <div className="currencies__table__data hide__in-mobile">
                <Table
                  title={() => (
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      {`${CurrenciesResults?.length || '0'} ${'Currencies'}`}
                      <H3Button
                        buttonType={defaultButtonTypes.BLUE_ROUNDED}
                        text="+ New Currency"
                        onClick={() => setShowNewCurrencyModal(true)}
                        customClass="currencies__header__add-button hide__in-mobile"
                      />
                    </div>
                  )}
                  loading={getCurrenciesLoading || updateCurrenciesLoading || deleteCurrenciesLoading || getCurrencyConversionRateLoading || refreshCurrencyConversionRateLoading || updateOrgLoading}
                  showHeader
                  size="small"
                  scroll="scroll"
                  columns={currenciesListColumns}
                  dataSource={CurrenciesResults || []}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Drawer
        open={showNewCurrencyModal}
        width="360px"
        mask
        onClose={() => setShowNewCurrencyModal(false)}
        destroyOnClose
        loading={getCurrenciesLoading || updateCurrenciesLoading || deleteCurrenciesLoading || getCurrencyConversionRateLoading || refreshCurrencyConversionRateLoading || updateOrgLoading}
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '315px' }}>
            <H3Text text="Add New Currency" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowNewCurrencyModal(false)} />
          </div>
        </div>
        <div className="create-po__new-vendor-wrapper">
          <CurrenciesForm
            currencies={currencies}
            oldCurrencies={CurrenciesResults?.map((curr) => curr?.currency_code)}
            callback={() => {
              getCurrencies(user?.tenant_info?.org_id);
              setShowNewCurrencyModal(false);
            }}
            paymentTerms={CurrenciesResults}
          />
        </div>
      </Drawer>
      <Drawer
        title="Update Currency"
        open={showUpdateCurrencyModal}
        onClose={() => setShowUpdateCurrencyModal(false)}
        width="360px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '315px' }}>
            <H3Text text="Update Conversion Rate" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowUpdateCurrencyModal(false)} />
          </div>
        </div>
        <CurrenciesForm
          currencies={currencies}
          selectedCurrencyUpdate={selectedCurrency}
          callback={() => {
            getCurrencies(user?.tenant_info?.org_id);
            setShowUpdateCurrencyModal(false);
          }}
        />
      </Drawer>
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers, CurrenciesReducers }) => ({
  user: UserReducers.user,
  CurrenciesResults: CurrenciesReducers.CurrenciesResults,
  getCurrenciesLoading: CurrenciesReducers.getCurrenciesLoading,
  updateCurrenciesLoading: CurrenciesReducers.updateCurrenciesLoading,
  deleteCurrenciesLoading: CurrenciesReducers.deleteCurrenciesLoading,
  getCurrencyConversionRateLoading: CurrenciesReducers.getCurrencyConversionRateLoading,
  currencyConversionRateResults: CurrenciesReducers.currencyConversionRateResults,
  refreshCurrencyConversionRateLoading: CurrenciesReducers.refreshCurrencyConversionRateLoading,
  updateOrgLoading: UserReducers.updateOrgLoading,
  org: UserReducers.org,
  getOrgLoading: UserReducers.getOrgLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getCurrencies: (orgId, callback) => dispatch(CurrenciesActions.getCurrencies(orgId, callback)),
  updateCurrencies: (payload, callback) => dispatch(CurrenciesActions.updateCurrencies(payload, callback)),
  deleteCurrencies: (payload, callback) => dispatch(CurrenciesActions.deleteCurrencies(payload, callback)),
  getCurrencyConversionRate: (payload, callback) => dispatch(CurrenciesActions.getCurrencyConversionRate(payload, callback)),
  refreshCurrencyConversionRate: (payload, callback) => dispatch(CurrenciesActions.refreshCurrencyConversionRate(payload, callback)),
  updateOrg: (payload, callback) => dispatch(UserActions.updateOrg(payload, callback)),
  getUserProfile: () => dispatch(UserActions.getUserProfile()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Currencies));
